import styled from 'styled-components'
import BaseWorkspaceLogo from 'modules/workspace/components/WorkspaceLogo'
import Avatar from 'components/Avatar'
import { animated } from 'react-spring'

export const Wrapper = styled.div`
  margin-top: 16px;
  width: 100%;
  position: relative;
  margin-bottom: 40px;
`

export const ItemWrapper = styled(animated.div)`
  display: flex;
  align-items: center;

  max-width: 512px;
  background-color: ${({ theme }) => theme.colors.background.secondary[2]};
  padding: 24px 12px;
  border-radius: 6px;
`

export const WorkspaceLogo = styled(BaseWorkspaceLogo)`
  margin-right: 16px;
`

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.text.dark.primary};

  font-size: 0.8125rem;
  line-height: 1.5;

  overflow: hidden;
  text-overflow: ellipsis;

  b {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text.dark.base};
    white-space: nowrap;
  }
`

export const InviterAvatar = styled(Avatar)`
  min-width: 32px;
  margin-right: 12px;
`
